import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { UseraccessserviceService } from 'src/app/services/useraccessservice.service';
import { ComponentheaderService } from 'src/app/services/componentheader.service';

@Component({
  selector: 'app-resendverificationemail',
  templateUrl: './resendverificationemail.component.html',
  styleUrls: ['./resendverificationemail.component.css']
})
export class ResendverificationemailComponent implements OnInit {

  resendForm: FormGroup;
  isLoading: boolean;
  confirmemail = false;
  isResendError = false;
  resendMsg = "";

  constructor(private userservice: UseraccessserviceService, private toastr: ToastrService, private headerinfo: ComponentheaderService) {
    this.resendForm = new FormGroup({
      email: new FormControl('', [Validators.required, Validators.email]),
    });
  }

  ngOnInit(): void {
    this.headerinfo.setPageTitle('Resend Verification Email');
  }

  async OnSubmit() {
    if (!this.resendForm.valid) {
      return;
    }

    const email = this.resendForm.get('email').value;

    this.isLoading = true;
    this.isResendError = false;
    this.resendForm.disable();

    try {
      const data: any = await this.userservice.resendconfirmationemail(email).toPromise();
      this.toastr.success(data.msg);
      this.confirmemail = true;
    }
    catch (err) {
      console.log(err);
      this.isResendError = true;
      this.resendMsg = "We could not send the verification email. Please check the address and try again.";
    }
    finally {
      this.isLoading = false;
      this.resendForm.enable();
    }
  }
}
